import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propArrayShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import DateText from '../../../../../../Ui/Common/DateText';
const ShareTableRowName = (props) => {
    const { createdAt, members } = props;
    const viewName = useMemo(() => members
        .map((v) => `${v.lastName} ${v.firstName}`.trim() || v.email)
        .join('、'), [members]);
    return (_jsxs("div", Object.assign({ className: 'user_col_information' }, { children: [_jsxs("h5", Object.assign({ className: 'user_col_title' }, { children: [_jsx("span", Object.assign({ className: 'user_col_title_body' }, { children: viewName })), members.length > 1 && (_jsx("span", Object.assign({ className: 'user_col_title_prefix' }, { children: `+${members.length - 1}` })))] })), _jsx("div", Object.assign({ className: 'user_col_received' }, { children: _jsx("span", Object.assign({ className: 'received_text' }, { children: _jsx(DateText, { format: 'YYYY/MM/DD', value: createdAt }) })) }))] })));
};
ShareTableRowName.propTypes = {
    createdAt: propStr().isRequired,
    members: propArrayShape().isRequired,
};
export default ShareTableRowName;
